export const PUBLIC_ORIGIN = "https://sightqoricancha.com";
export const ADMIN_ORIGIN = "https://admin.sightqoricancha.com";
export const ADMIN_HOST = "admin.sightqoricancha.com";

export function isPublicHost(hostname: string) {
  return hostname === "sightqoricancha.com" || hostname === "www.sightqoricancha.com";
}

export function staffSignInUrl(hostname: string, language = "en") {
  return `${isPublicHost(hostname) ? ADMIN_ORIGIN : ""}/staff/login?lang=${language === "es" ? "es" : "en"}`;
}

export function safeStaffDestination(path: unknown): string {
  return typeof path === "string" && /^\/staff(?:\/(?!login(?:[/?#]|$))[^\\?#]*)?(?:\?[^\\#]*)?$/.test(path)
    ? path : "/staff";
}
